import { type FormikValues, useFormikContext } from 'formik';
import React, { useEffect } from 'react';

import { Input, type InputProps } from '@components/Input/Input';
import { EStyles } from '@enums/style.enum';

interface Props extends InputProps {
	firstValue?: unknown;
	name: string;
	placeholder?: string;
	onChangeCallBack?: (name: string, text: string) => void;
}

const FormInput: React.FC<Props> = ({
	firstValue,
	name,
	numbersOnly = false,
	numbersAndLettersOnly = false,
	placeholder,
	onChangeCallBack,
	width,
	inputMode,
	autoCapitalize,
	maxLength,
	displayError,
	...otherProps
}: React.PropsWithChildren<Props>) => {
	const { setFieldTouched, setFieldValue, errors, touched, values } = useFormikContext<FormikValues>();

	const isError = !!touched[name] && !!errors[name];

	const handleFirstValue = (firstValue: unknown) => {
		setFieldValue(name, firstValue);
	};

	const handleOnChangeText = (text: string) => {
		onChangeCallBack?.(name, text);
		setFieldValue(name, text);
	};

	useEffect(() => {
		handleFirstValue(firstValue);
	}, [firstValue]);

	return (
		<Input
			numbersAndLettersOnly={numbersAndLettersOnly}
			numbersOnly={numbersOnly}
			placeholder={placeholder}
			value={values[name] || EStyles.emptyQuote}
			onTextChange={handleOnChangeText}
			inputMode={inputMode}
			autoCapitalize={autoCapitalize}
			maxLength={maxLength}
			error={isError ? String(errors[name]) : undefined}
			onBlur={() => setFieldTouched(name)}
			displayError={displayError}
			style={{ height: 40, minHeight: 40, fontSize: 16, textAlign: 'left', backgroundColor: 'var(--background)' }}
			{...otherProps}
		/>
	);
};

export default FormInput;
